export const TypeIcon = {
    SIMULADOR: { value: 'Simulador', icon: 'fa-calculator'},
    CENSO: { value: 'Censo', icon: 'fa-id-card'},
    ARRECADACAO: { value: 'Arrecadação', icon: 'fa-coins'},
    CADASTRO: {value: 'Cadastro', icon:  'fa-id-card'}
}